import script from "./UCConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./UCConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./UCConfirmation.vue?vue&type=style&index=0&id=67d36de8&lang=scss"

const __exports__ = script;

export default __exports__